<iframe
  src="https://clienthub.app/app-welcome"
  frameborder="0"
  class="welcome-iframe"
></iframe>
